import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import type { ClientStatistic, NumberOfStatistic } from '../../common/types/statistics/fbStatistics';

const statisticsOrder: {
  key: keyof NumberOfStatistic;
  label: string;
}[] = [
  {
    key: 'totalNumber',
    label: 'Gesamtzahl der Beratungsfälle',
  },
  {
    key: 'numberOfMinors',
    label: 'Kinder unter 18',
  },
  {
    key: 'numberOfSingleParents',
    label: 'Alleinerziehende',
  },
  {
    key: 'numberOfImmigrationBackground',
    label: 'Migrationshintergrund',
  },
  {
    key: 'numberOfFleeingBackground',
    label: 'Fluchthintergrund',
  },
  {
    key: 'numberOfTranslationNecessary',
    label: 'Sprachmittlung nötig',
  },
  {
    key: 'numberOfPartnerHasMentalIllness',
    label: 'Partner*in hat eine psychische Erkrankung',
  },
  {
    key: 'numberOfPartnerHasAddiction',
    label: 'Partner*in hat eine Suchterkrankung',
  },
];

type Props = {
  clientStatistics: ClientStatistic;
};

function InformationStatistic({ clientStatistics }: Props) {
  return (
    <Stack direction='column'>
      {statisticsOrder.map(({ key, label }) => (
        <Typography key={key}>
          {label}: {clientStatistics[key]}
        </Typography>
      ))}
    </Stack>
  );
}

export default InformationStatistic;
